import { render, staticRenderFns } from "./CabinSetupItem.vue?vue&type=template&id=1a5462d5&scoped=true"
import script from "./CabinSetupItem.vue?vue&type=script&lang=js"
export * from "./CabinSetupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5462d5",
  null
  
)

export default component.exports